import React from "react";
import { BACKGROUND_COLOR, RUBRIC_COLOR, TEXT_COLOR } from "./tokens";

export const LogoLink: React.FC<{}> = () => {
    return (
        <a
            href="/"
            style={{
                color: BACKGROUND_COLOR,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontWeight: "bold",
            }}
        >
            <div
                style={{
                    display: "flex",
                    paddingRight: 8,
                }}
            >
                <img
                    src={new URL("favicon.png", import.meta.url).href}
                    style={{
                        width: 30,
                        height: 30,
                        borderRadius: 4,
                    }}
                />
            </div>
            <div style={{ color: TEXT_COLOR }}>Sing</div>
            <div style={{ color: RUBRIC_COLOR }}>The</div>
            <div style={{ color: TEXT_COLOR }}>Office</div>
        </a>
    );
};
